import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { format } from 'date-fns';
import { userIncludesRequiredFieldsForEmployment } from 'server/shared/helpers/canBookInviteeForJob';
import { Customer } from 'server/shared/models/customer';
import { EmploymentInvitee } from 'server/shared/models/employmentInvitee';
import { DispoUser, PoolerUser } from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';
import {
  getAvailabilityMatchPercentage,
  getAvailabilityMatchPercentageRange,
} from '../../../helpers/employment/getAvailabilityMatchPercentage';
import { PreparedEmploymentPoolerUser } from '../../../types/employment/PreparedEmploymentPoolerUser';
import { ToastService } from '../../services/toast/toast.service';
import {
  RequiredFieldsDialog,
  RequiredFieldsDialogUpdatedFields,
} from '../required-fields-dialog/required-fields.component';

@Component({
  selector: 'app-employment-user-list-item',
  templateUrl: './employment-user-list-item.component.html',
  styleUrls: ['./employment-user-list-item.component.scss'],
})
export class EmploymentUserListItemComponent implements OnInit {
  // invitee exists only for already invited users
  @Input() invitee?: EmploymentInvitee;
  @Input() user?: PreparedEmploymentPoolerUser;
  @Input() loggedInUser?: DispoUser;
  @Input() fromDate?: Date;
  @Input() toDate?: Date;
  @Input() workload?: number;
  @Input() employmentCustomer?: Customer;
  @Input() loggedInCustomer?: Customer;
  @Input() departmentId?: string;

  @Input() inviteCheckboxEnabled = false;
  @Output() inviteCheckboxChange = new EventEmitter<boolean>();

  @HostBinding('class.undecided-availability') isUndecided = false;

  detailsCollapsed = true;
  availabilityPercentage: number = 0;
  @HostListener('click') onClick() {
    this.detailsCollapsed = !this.detailsCollapsed;
  }

  constructor(
    private dialog: MatDialog,
    private toastService: ToastService,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    if (this.user && this.fromDate && this.toDate) {
      this.availabilityPercentage = getAvailabilityMatchPercentage(
        this.user.employmentAvailabilityDays || [],
        getAvailabilityMatchPercentageRange(
          format(this.fromDate, dbDayDateToken),
          format(this.toDate, dbDayDateToken),
        ),
        this.workload || 100,
      );
      if (this.availabilityPercentage === 0) {
        this.isUndecided = true;
      }
    }
  }

  onSelectionChange(skipCheck?: boolean) {
    let user = this.user as PoolerUser;
    if (!this.employmentCustomer || !this.user) {
      return;
    }
    if (
      !userIncludesRequiredFieldsForEmployment(user, this.employmentCustomer) &&
      this.inviteCheckboxEnabled &&
      !skipCheck
    ) {
      const dialogRef = this.dialog.open(RequiredFieldsDialog, {
        data: {
          user,
          requiredFields: this.employmentCustomer?.requiredJobFields,
        },
      });

      dialogRef
        .afterClosed()
        .subscribe((result: RequiredFieldsDialogUpdatedFields) => {
          if (result) {
            Meteor.call(
              'updateRequiredFields',
              user._id,
              result,
              (error: Meteor.Error) => {
                if (error) {
                  this.toastService.add({
                    type: 'ERROR',
                    message: 'serverError',
                  });
                  this.inviteCheckboxEnabled = false;
                  return;
                } else {
                  this.onSelectionChange(true);
                }
              },
            );
          } else {
            this.inviteCheckboxEnabled = false;
          }
        });
      return;
    }
    this.inviteCheckboxChange.emit(this.inviteCheckboxEnabled);
  }
}
